import { render, staticRenderFns } from "./BrunetteWaiting1.vue?vue&type=template&id=698f4d1a&"
import script from "./BrunetteWaiting1.vue?vue&type=script&lang=ts&"
export * from "./BrunetteWaiting1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports